<template>
  <div class="maintenance" :class="theme">
    <div class="card">
      <h1>{{ t.title }}</h1>

      <p v-html="t.desc"></p>

      <div class="loader"></div>

      <!-- Langues -->
      <div class="lang">
        <button @click="setLang('fr')">FR</button>
        <button @click="setLang('ar')">AR</button>
        <button @click="setLang('en')">EN</button>
      </div>

      <small>© 2025 SupraCare.ma</small>
    </div>
  </div>
</template>

<script>
export default {
  name: "MaintenanceJ",
  data() {
    return {
      // 🔧 CONFIG
      showCountdown: true, // true = avec / false = sans
         endDate: 1737396000000,

      // STATE
       hours: 0,
       minutes: 0,
      seconds: 0,
      lang: "fr",
      theme: "dark",
      timer: null,

      texts: {
        fr: {
          title: "🚧 Site en maintenance",
          desc: "Le site <strong>SupraCare</strong> est temporairement indisponible.<br>Merci pour votre patience.",
          backIn: "Retour dans"
        },
        en: {
          title: "🚧 Website under maintenance",
          desc: "The <strong>SupraCare</strong> website is temporarily unavailable.<br>Please come back soon.",
          backIn: "Back in"
        },
        ar: {
          title: "🚧 الموقع قيد الصيانة",
          desc: "موقع <strong>SupraCare</strong> غير متاح مؤقتًا.<br>شكرًا لتفهمكم.",
          backIn: "العودة بعد"
        }
      }
    };
  },
  computed: {
    t() {
      return this.texts[this.lang];
    }
  },
  mounted() {
    // Light / Dark automatique
    const prefersDark = window.matchMedia("(prefers-color-scheme: dark)").matches;
    this.theme = prefersDark ? "dark" : "light";

    // Langue navigateur
    const browserLang = navigator.language.slice(0, 2);
    if (this.texts[browserLang]) {
      this.lang = browserLang;
    }

    // Countdown
    if (this.showCountdown) {
    this.updateCountdown(); // premier calcul
    this.timer = setInterval(this.updateCountdown, 1000);
  }

    document.documentElement.dir = this.lang === "ar" ? "rtl" : "ltr";
  },
  beforeUnmount() {
    clearInterval(this.timer);
  },
  methods: {
    setLang(l) {
      this.lang = l;
      document.documentElement.dir = l === "ar" ? "rtl" : "ltr";
    },
    updateCountdown() {
      const now = Date.now();
    const diff = this.endDate - now;

    if (diff <= 0) {
      this.hours = 0;
      this.minutes = 0;
      this.seconds = 0;
      clearInterval(this.timer);
      return;
    }

    this.hours = Math.floor(diff / (1000 * 60 * 60));
    this.minutes = Math.floor((diff / (1000 * 60)) % 60);
    this.seconds = Math.floor((diff / 1000) % 60);
    }
  }
};
</script>

<style scoped>
/* THEMES */
.dark {
  --bg: #020617;
  --card: rgba(255,255,255,0.05);
  --text: #ffffff;
}

.light {
  --bg: #f8fafc;
  --card: #ffffff;
  --text: #0f172a;
}

.maintenance {
  min-height: 100vh;
  background: var(--bg);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--text);
  font-family: Poppins, sans-serif;
}

.card {
  background: var(--card);
  padding: 40px;
  border-radius: 20px;
  text-align: center;
  max-width: 520px;
  width: 100%;
  box-shadow: 0 20px 40px rgba(0,0,0,0.3);
}

h1 {
  color: #00998b;
  margin-bottom: 15px;
}

.countdown {
  margin: 15px 0;
  font-size: 1.2rem;
  font-weight: bold;
  color: #00998b;
}

.loader {
  margin: 25px auto;
  width: 45px;
  height: 45px;
  border: 4px solid rgba(0,0,0,0.1);
  border-top: 4px solid #00998b;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

.dark .loader {
  border: 4px solid rgba(255,255,255,0.3);
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

.lang button {
  margin: 5px;
  padding: 8px 14px;
  border: none;
  border-radius: 20px;
  background: #00998b;
  color: white;
  cursor: pointer;
  font-weight: 600;
}

small {
  opacity: 0.6;
  display: block;
  margin-top: 15px;
}
</style>
